import React from 'react';
import colors from '../../theme/colors';

const badgeColors = {
  green: { bg: 'rgba(81,207,102,0.15)', text: colors.success },
  yellow: { bg: 'rgba(255,212,59,0.15)', text: colors.warning },
  red: { bg: 'rgba(255,107,107,0.15)', text: colors.danger },
  gray: { bg: 'rgba(136,136,136,0.15)', text: colors.textMuted },
  cyan: { bg: 'rgba(0,212,255,0.15)', text: colors.accent },
};

export default function StatusBadge({ label, color = 'gray' }) {
  const c = badgeColors[color] || badgeColors.gray;
  return (
    <span style={{
      display: 'inline-block',
      padding: '3px 10px',
      borderRadius: 10,
      fontSize: 12,
      fontWeight: 600,
      background: c.bg,
      color: c.text,
    }}>
      {label}
    </span>
  );
}
